import * as Consts from "../ts/rlAdmin.consts";
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as angular from "angular";
import { NotifyService } from "../services/notify-service";
import { SearchService } from "../services/search-service";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";
import { AclService } from "../services/acl-service";
import { ISearchCommand } from "../controllers/_baseSearchController";


export interface IRLAdvancedSearchScope extends ng.IScope {
    charTypeId: number;
}

export function RLAdvancedSearch(): ng.IDirective {
    return {
        restrict: 'E',
        template: require("/assets/app/templates/advanced-search.html"),
        scope: {
            charTypeId: '=',
            itemRows: '=',
            qTime: '=',
            numFound: '=',
            pageCount: '=',
            sortDir: '=',
            sortField: '=',
            page: '=',
            selectedTemplate: '=',
            selectedStatus: '=',
            keywords: '=',
            searching: '=',
            templateGroupIds: '=?',
            lockTemplate: '@?',
            search: '=?',
            rowCount: '=?',
            selectedColumns: '=?',
            selectedItems: '=?'
        },
        controller: RLAdvancedSearchController,
        controllerAs: 'asVM',
        bindToController: true,
        transclude: true,
        require: ["rlAdvancedSearch", "^ngController"],
        link: (scope: IRLAdvancedSearchScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrls: [RLAdvancedSearchController, ISearchCommand]) => {
            ctrls[1].onPushState = () => { ctrls[0].PushState() };
        }
    }
}

export class RLAdvancedSearchController {
    static $inject = ['$scope', '$timeout', '$window', "$q", "$location", 'notifyService', 'searchService', 'entityConfigService', 'entityService', "aclService"];
    loadingMetaData: boolean;
    initialized: boolean;
    charTypeId: number;
    selectedCharTypeID: number;
    // dictionary keyed on charTypeID:characteristicID with the actual multiIndicator
    multiIndicatorRestoreDictionary: { [ctCmd: string]: { multiIndicator?: number; maxLength?: number } };
    charTypes: Models.ICharacteristicType[];
    relationshipTypes: Models.ICharacteristicType[];
    relatedParties: Models.IParty[];
    searchGroups: Models.ISearchGroup[];
    addSearchGroups: Models.ISearchGroup[] = [];
    currentComparators: { [id: number]: string };
    operators: { [id: number]: string };
    showAdvanced: boolean;
    charMetaDatas: Models.ITemplateCharacteristicMetaData[];
    lovMetaDatas: { [charValueSourceID: string]: Models.ICharLovMetaData };
    currentEditSearchGroups: Models.ISearchGroup[];
    //oldOperation: Models.ISearchOperation;
    //currentOperation: Models.ISearchOperation;
    openModal: boolean;
    itemRows: any[];
    qTime: number;
    numFound: number;
    pageCount: number;
    page: number;
    rowCount: number;
    keywords: string;
    relatedToMe: boolean;
    sortDir: number;
    sortField: string;
    searching: boolean;
    search: boolean;
    selectedStatus: string;                                     // current selected	status
    lockTemplate: boolean;                                      // lock this search to a specific template
    selectedTemplate: string;                                   // current selected	template
    templateFacets: Models.IKeyValuePair<string, string>[];
    statusFacets: Models.IKeyValuePair<string, string>[];
    templateGroupIds: number[];
    relatedCharTypeIDs: number[];
    _selectedSavedSearch: Models.ISaveSearchModel;  // backing field for getter / setter
    savedSearches: Models.ISaveSearchModel[];
    showSave: boolean;
    saveSearchModel: Models.ISaveSearchModel;
    saveAsSearchName: string;
    sortFieldChanged: boolean;
    bypass: boolean;
    selectedColumns: Models.ICustomUserColumns;
    selectedItems: { [key: string]: boolean };
    visibleTemplates: Models.ICharacteristicTemplate[];
    searchCriteriaEditMode: boolean;

    searchHistoryInitialized = false;

    constructor(
        private $scope: IRLAdvancedSearchScope,
        private $timeout: ng.ITimeoutService,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private $location: ng.ILocationService,
        private notifyService: NotifyService,
        private searchService: SearchService,
        private entityConfigService: EntityConfigService,
        private entityService: EntityService,
        private aclService: AclService) {
        
    }

    $onInit(){
        this.initialized = false;
        this.multiIndicatorRestoreDictionary = {};
        this.operators = {};
        this.searchGroups = [];
        this.openModal = false;
        this.relatedToMe = false;
        this.loadingMetaData = false;
        this.showAdvanced = false;
        this.lockTemplate = false;
        //this.rowCount = 25;
        this.showSave = false;
        this.sortFieldChanged = false;
        this.lovMetaDatas = {};
        this.ResetSaveModel();
        this.savedSearches = [];
        
        this.initialize();
        this.bypass = false;
        this.visibleTemplates = [];
        this.searchCriteriaEditMode = false;
        this.currentEditSearchGroups = [];
        
        this.$scope.$watchCollection(() => [this.selectedTemplate, this.charTypeId], (newValue) => {
            this.selectedCharTypeID = this.charTypeId;
            if (newValue[0] && !this.lockTemplate) {
                this.loadCharMetaData(this.charTypeId);
            }

            this.loadSavedSearches();
        });

        for (var operator in Consts.AdvancedSearch.Operator) {
            if (typeof Consts.AdvancedSearch.Operator[operator] !== 'number') {
                this.operators[operator] = Consts.AdvancedSearch.Operator[operator];
            }
        }

        if (!this.$location.search()["s"]) {
            this._pushState();
        }

        this.$scope.$watch(() => this.$location.search(), (newValue, oldValue) => {

            var searchState = this.GetState();
            this.keywords = searchState.k || "";
            this.page = _.parseInt(searchState.p || 1);
            this.selectedStatus = searchState.s || null;
            this.selectedTemplate = searchState.t || null;
            this.relatedToMe = _.parseInt(searchState.rtm || 0) > 0;
            this.rowCount = searchState.ps || 25;
            this.sortField = searchState.sf || "";
            this.sortDir = _.parseInt(searchState.sd || 0);
            this.searchGroups = searchState.sg || [];
            this.selectedColumns = searchState.sc || this.selectedColumns;

            if (!this.searchHistoryInitialized) {
                this.InitializeSearchHistoryMetaData().then(() => {
                    this.searchHistoryInitialized = true;
                    this.Search();
                })
            } else {
                this.Search();
            }

        }, true);
    }

    InitializeSearchHistoryMetaData() {
        //this.searchGroups.forEach((group) => {
        //    group.operations.forEach((op) => {
        //        this.adjustCharMetaData(op.charTypeID, op.characteristicMetaData[0]);
        //    });
        //});
        var charTypeIDs = _.uniq(_.flatten(this.searchGroups.map(g => g.operations.map(op => op.charTypeID > 0 ? op.charTypeID : Consts.CharTypeIDs.user))));
        var promises = [this.loadCharMetaData(this.charTypeId), ...charTypeIDs.map((ct) => this.getCharMetaData(ct))];
        return this.$q.all(promises);
        //charTypeIDs.map((ct)=> this.getCharMetaData(
    }

    PushState(resetPage: boolean = false) {
        if (resetPage) {
            this.page = 1;
        }
        // this timeout gives the directive a scope tick to update all the scope bound variables
        this.$timeout(() => {
            this._pushState();
        });
    }

    private _pushState() {
        var newState = { k: this.keywords, t: this.selectedTemplate || null, s: this.selectedStatus || null, p: this.page, sf: this.sortField || "", sd: this.sortDir || 0, rtm: this.relatedToMe ? 1 : 0, sg: this.searchGroups, ps: this.rowCount, sc: this.selectedColumns };
        this.$location.search({ s: this.encodeState(newState) });

    }


    GetState() {
        var search = this.$location.search().s || this.encodeState({});
        return this.decodeState(search);
    }

    ClickSearch() {
        this.sortField = "";
        this.PushState(true);
    }

    private encodeState(state: {}) {
        return window.btoa(JSON.stringify(state,
            (key, value) => {
                if (typeof value == "string") {
                    return encodeURIComponent(value);
                }
                return value;
            }));
    }

    private decodeState(state: string) {
        return JSON.parse(window.atob(state), (key, value) => {
            if (typeof value == "string") {
                return decodeURIComponent(value);
            }
            return value;
        })
    }



    private initialize() {
        this.entityConfigService.getCharacteristicTypes()
            .then((res) => {
                this.charTypes = res;
            });
    }

    private getVisibleTemplates() {
        var deferred = this.$q.defer<Models.ICharacteristicTemplate[]>();
        if (this.visibleTemplates.length > 0) {
            deferred.resolve(this.visibleTemplates);
        }
        else {
            this.entityConfigService.getCharacteristicTemplates(this.charTypeId)
                .then((result) => {
                    this.visibleTemplates = _.filter(result, t => Utils.AclUtil.hasReadAccess(this.aclService.acls, t.acl));
                })
                .finally(() => {
                    deferred.resolve(this.visibleTemplates);
                });
        }
        return deferred.promise;
    }

    private populateRelationships() {
        if (!this.relationshipTypes) {
            this.relationshipTypes = [];
            this.relationshipTypes = this.getRelationships(this.charTypeId);
        }
    }

    public getRelationships(charTypeId: number): Models.ICharacteristicType[] {

        var ret: Models.ICharacteristicType[] = _.filter(this.charTypes, (ct) => {
            return ct.charTypeID == this.charTypeId || this.relatedCharTypeIDs.indexOf(ct.charTypeID) > -1;
        });

        // add parties to 'relationshipTypes' with negative partyID's as the charTypeID
        if (this.relatedParties && this.relatedParties.length > 0) {
            this.relatedParties.forEach((party, index) => {
                ret.push({
                    charTypeID: -party.partyID,
                    charTypeName: "Party: " + party.partyName,
                    seqNumber: index
                });
            });
        }

        return ret;
    }

    private adjustCharMetaData(relationshipID: number, cmd: Models.ICharacteristicMetaData) {
        //cmd.editIndicator = 1;
        cmd.requiredIndicator = 0;

        switch (cmd.dataTypeID) {
            case Consts.CharDataTypeIDs.CharDataTypes.file:
                var key = this.getCmdHash(relationshipID, cmd.characteristicID);
                var oldDataType = {
                    datTypeID: cmd.dataTypeID,
                    maxLength: cmd.maxLength
                }
                this.multiIndicatorRestoreDictionary[key] = oldDataType;
                cmd.dataTypeID = Consts.CharDataTypeIDs.CharDataTypes.alphanumeric;
                if (cmd.maxLength > 254) {
                    this.multiIndicatorRestoreDictionary[key] = old;
                    cmd.maxLength = 254;
                }
                break;
            case Consts.CharDataTypeIDs.CharDataTypes.url:
            case Consts.CharDataTypeIDs.CharDataTypes.email:
            case Consts.CharDataTypeIDs.CharDataTypes.alphanumeric:
                {
                    var key = this.getCmdHash(relationshipID, cmd.characteristicID);
                    var old = {
                        multiIndicator: cmd.multipleIndicator,
                        maxLength: cmd.maxLength
                    }
                    // allow multi input for these data types
                    if (!cmd.multipleIndicator) {
                        this.multiIndicatorRestoreDictionary[key] = old;
                        cmd.multipleIndicator = 1;
                    }

                    // get rid of the textarea inputs - they look silly here
                    if (cmd.maxLength > 254) {
                        this.multiIndicatorRestoreDictionary[key] = old;
                        cmd.maxLength = 254;
                    }
                    break;
                }
        }
    }

    public getCharMetaData(charTypeID: number): ng.IPromise<Models.ITemplateCharacteristicMetaData[]> {

        var effectiveCharTypeID: number = (charTypeID > 0) ? charTypeID : Consts.CharTypeIDs.user;  // charTypeID < 0 => PTY table
        var template: string = this.charTypeId === charTypeID ? this.selectedTemplate : "";

        var promises: ng.IPromise<any>[] = [];

        var metadataPromise: ng.IPromise<Models.ITemplateCharacteristicMetaData[]> = this.searchService.getAdvancedMetaData(effectiveCharTypeID, template)
            .then((res) => {
                // blacklist certain data types or whitelist appropriate data types?
                var ignoreDataTypeIDs = [
                    Consts.CharDataTypeIDs.CharDataTypes.password,
                    //Consts.CharDataTypeIDs.CharDataTypes.file,
                    Consts.CharDataTypeIDs.CharDataTypes.creditcard
                ];

                var ret: Models.ITemplateCharacteristicMetaData[] = _.filter(res.templateCharacteristicMetaDatas, (tcmd) => {
                    return ignoreDataTypeIDs.indexOf(tcmd.characteristicMetaData.dataTypeID) == -1;
                });

                ret = _.sortBy(ret, (cmd) => {
                    return cmd.characteristicMetaData.label;
                });

                // we need to make all of these editable and remove required validators
                ret.forEach((tcmd) => {
                    this.adjustCharMetaData(charTypeID, tcmd.characteristicMetaData);
                });

                // TOOD: Need to factor this back in...
                // - fetch related LOV data
                res.templateCharacteristicMetaDatas
                    .filter((cmd) => !_.isEmpty(cmd.characteristicMetaData.charValueSourceID))
                    .forEach((cmd) => {
                        var promise = this.entityService.getCharLovMetaData(cmd.characteristicMetaData.charValueSourceID, cmd.characteristicMetaData.charValueSetID)
                            .then((result2) => {
                                this.lovMetaDatas[cmd.characteristicMetaData.charValueSourceID] = result2;
                            });
                        promises.push(promise);
                    });

                // - setup related data (if data is for the current char type)
                // only set related char types if we are loading metadata for the current char type
                if (effectiveCharTypeID == this.charTypeId) {
                    this.relatedCharTypeIDs = res.relatedCharTypeIDs;
                    this.relatedParties = res.parties;

                    var charIds = _.map(this.charMetaDatas, (tcmd) => {
                        return tcmd.characteristicMetaData.characteristicID;
                    });

                    // TODO: Sub-method
                    // NOTE: Don't need to do this here at all
                    // Q: Should we be doing this elsewhere - on the criteria control - if they edit?
                    // remove invalid operations

                    // remove operations with now-invalid characteristics
                    _.each(this.searchGroups, (group) => {
                        _.each(group.operations, (op) => {

                            if (op.characteristicMetaData[0].charTypeID == this.selectedCharTypeID) {
                                if (!_.contains(charIds, op.characteristicMetaData[0].characteristicID)) {
                                    this.removeOperation(op);
                                }
                            }
                        });
                    });
                }

                this.$q.all(promises);
                return ret;
            })
            .finally(() => {
            });
        return metadataPromise;
    }

    metaDataPromise: ng.IPromise<Models.ITemplateCharacteristicMetaData[]>;
    //private loadCharMetaData(charTypeID: number): ng.IPromise<Models.ITemplateCharacteristicMetaData[]> {
    public loadCharMetaData(charTypeID: number): ng.IPromise<Models.ITemplateCharacteristicMetaData[]> {

        var metaDataPromise: ng.IPromise<Models.ITemplateCharacteristicMetaData[]>;
        var promises: ng.IPromise<any>[] = [];

        if (!this.loadingMetaData) {
            this.loadingMetaData = true;
            this.notifyService.startProgress();
            metaDataPromise = this.getCharMetaData(charTypeID)
                .then((res) => {
                    this.charMetaDatas = res;
                    return this.$q.all(promises);
                })
                .finally(() => {
                    this.populateRelationships();
                    this.notifyService.endProgress();
                    this.initialized = true;
                    this.loadingMetaData = false;
                });

            this.metaDataPromise = metaDataPromise;
        }
        return this.metaDataPromise;
    }

    private removeOperation(operation: Models.ISearchOperation) {

        var searchGroups = _.cloneDeep(this.searchGroups);

        this.searchGroups = searchGroups
            .map((group) => {
                group.operations = group.operations.filter((op) => !angular.equals(op, operation));
                return group;
            })
            .filter((group) => group.operations.length > 0);



        //var groupCount = this.searchGroups.length;
        //while (groupCount--) {
        //    var group = this.searchGroups[groupCount];
        //    var opCount = group.operations.length;
        //    while (opCount--) {
        //        var op = group.operations[opCount];
        //        if (op == operation) {
        //            group.operations.splice(opCount, 1);
        //            break;
        //        }
        //    }

        //    if (group.operations.length === 0) {
        //        this.searchGroups.splice(groupCount, 1);
        //    }
        //}
    }

    // TODO: redo this (╯°□°）╯︵ ┻━┻
    /*
    private getComparators(cmd: Models.ICharacteristicMetaData): { [id: number]: string } {
    */
    public getComparators(cmd: Models.ICharacteristicMetaData): { [id: number]: string } {
        var comparators: { [id: number]: string } = {};
        var notSameCharTypeID: boolean = false;
        if (this.charTypeId != this.selectedCharTypeID) {
            notSameCharTypeID = true;
        }

        switch (cmd.dataTypeID) {
            case Consts.CharDataTypeIDs.CharDataTypes.url:
            case Consts.CharDataTypeIDs.CharDataTypes.email:
            case Consts.CharDataTypeIDs.CharDataTypes.alphanumeric:
                {
                    if (cmd.multipleIndicator > 0) {
                        // lovs
                        if (cmd.charValueSourceID) {
                            comparators[Consts.AdvancedSearch.Comparator.Equal] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.Equal, cmd);
                            comparators[Consts.AdvancedSearch.Comparator.EqualAny] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.EqualAny, cmd);
                            if (!notSameCharTypeID) {
                                comparators[Consts.AdvancedSearch.Comparator.NotEqual] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.NotEqual, cmd);
                            }
                        }
                        // other multi
                        else {
                            comparators[Consts.AdvancedSearch.Comparator.Equal] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.Equal, cmd);
                            comparators[Consts.AdvancedSearch.Comparator.EqualAny] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.EqualAny, cmd);
                            if (!notSameCharTypeID) {
                                comparators[Consts.AdvancedSearch.Comparator.NotEqual] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.NotEqual, cmd);
                            }
                            comparators[Consts.AdvancedSearch.Comparator.Contains] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.Contains, cmd);
                            comparators[Consts.AdvancedSearch.Comparator.ContainsAll] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.ContainsAll, cmd);
                            if (!notSameCharTypeID) {
                                comparators[Consts.AdvancedSearch.Comparator.NotContains] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.NotContains, cmd);
                            }

                        }
                    } else {
                        comparators[Consts.AdvancedSearch.Comparator.Contains] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.Contains);
                        comparators[Consts.AdvancedSearch.Comparator.Equal] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.Equal);
                        if (!notSameCharTypeID) {
                            comparators[Consts.AdvancedSearch.Comparator.NotContains] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.NotContains, cmd);
                        }
                    }
                    break;
                }
            case Consts.CharDataTypeIDs.CharDataTypes.year:
            case Consts.CharDataTypeIDs.CharDataTypes.numeric:
            case Consts.CharDataTypeIDs.CharDataTypes.date:
            case Consts.CharDataTypeIDs.CharDataTypes.percentage:
            case Consts.CharDataTypeIDs.CharDataTypes.timecode:
            case Consts.CharDataTypeIDs.CharDataTypes.money:
            case Consts.CharDataTypeIDs.CharDataTypes.currency:
                {
                    comparators[Consts.AdvancedSearch.Comparator.Equal] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.Equal);
                    if (!notSameCharTypeID) {
                        comparators[Consts.AdvancedSearch.Comparator.NotEqual] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.NotEqual, cmd);
                    }
                    comparators[Consts.AdvancedSearch.Comparator.GreaterThan] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.GreaterThan);
                    comparators[Consts.AdvancedSearch.Comparator.LessThan] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.LessThan);
                    comparators[Consts.AdvancedSearch.Comparator.Between] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.Between);
                    break;
                }
            case Consts.CharDataTypeIDs.CharDataTypes.checkbox:
                {
                    comparators[Consts.AdvancedSearch.Comparator.Equal] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.Equal, cmd);
                    if (!notSameCharTypeID) {
                        comparators[Consts.AdvancedSearch.Comparator.NotEqual] = this.GetComparatorDisplayName(Consts.AdvancedSearch.Comparator.NotEqual, cmd);
                    }
                }
        }

        return comparators;
    }

    GetCharTypeName(charTypeID: number) {
        if (!this.relationshipTypes) return "";
        for (var i = 0; i < this.relationshipTypes.length; i++) {
            if (this.relationshipTypes[i].charTypeID == charTypeID) {
                return this.relationshipTypes[i].charTypeName;
            }
        }
    }

    ClearSearch(force: boolean = false) {
        this.searchGroups = [];
        this.keywords = "";
        this.relatedToMe = false;

        if (this.selectedSavedSearch || force) {
            if (!this.lockTemplate) {
                this.selectedTemplate = null;
            }

            this.selectedStatus = null;
        }

        this.selectedSavedSearch = null;
        this.page = 1;
    }

    ClearSearchKeywords() {
        this.keywords = "";
        this.PushState();
    }

    // TODO: redo this too (╯°□°）╯︵ ┻━┻
    GetComparatorDisplayName(comparator: Consts.AdvancedSearch.Comparator, cmd?: Models.ICharacteristicMetaData): string {
        if (!cmd || !cmd.multipleIndicator) {
            switch (comparator) {
                case Consts.AdvancedSearch.Comparator.Equal:
                    {
                        return "is equal to";
                    }
                case Consts.AdvancedSearch.Comparator.NotEqual:
                    {
                        return "does not equal";
                    }
                case Consts.AdvancedSearch.Comparator.LessThan:
                    {
                        return "is less than";
                    }
                case Consts.AdvancedSearch.Comparator.GreaterThan:
                    {
                        return "is greater than";
                    }
                case Consts.AdvancedSearch.Comparator.Contains:
                    {
                        return "contains";
                    }
                case Consts.AdvancedSearch.Comparator.NotContains:
                    {
                        return "does not contain";
                    }
                case Consts.AdvancedSearch.Comparator.Between:
                    {
                        return "is between";
                    }
                default:
                    throw Error("Invalid Comparator: " + comparator);
            }
        } else {
            switch (comparator) {
                case Consts.AdvancedSearch.Comparator.Equal:
                    {
                        return "equals all";
                    }
                case Consts.AdvancedSearch.Comparator.NotEqual:
                    {
                        return "equals none";
                    }
                case Consts.AdvancedSearch.Comparator.EqualAny:
                    {
                        return "equals any";
                    }
                case Consts.AdvancedSearch.Comparator.Contains:
                    {
                        return "contains any";
                    }
                case Consts.AdvancedSearch.Comparator.ContainsAll:
                    {
                        return "contains all";
                    }
                case Consts.AdvancedSearch.Comparator.NotContains:
                    {
                        return "contains none";
                    }
                case Consts.AdvancedSearch.Comparator.Between:
                    {
                        return "is between";
                    }
                default:
                    throw Error("Invalid Comparator:" + comparator);
            }
        }
    }

    public getEmptyCharData(cmd: Models.ICharacteristicMetaData): Models.ICharDataValue[] {
        return [
            {
                charID: cmd.characteristicID,
                recCharID: 0,
                value: ''
            }
        ];
    }

    public getFirstComparator(comparators: { [id: number]: string }): number {
        for (var key in comparators) {
            return parseInt(key);
        }
        return null;
    }

    private getCmdHash(relationshipID: number, characteristicID: number): string {
        return (relationshipID > 0 ? relationshipID : Consts.CharTypeIDs.user) + ":" + characteristicID;
    }

    ResetSaveModel() {

        this.showSave = false;
        this.saveAsSearchName = null;
        this.saveSearchModel = {
            showOnDashboard: false,
            searchRequest: this.getSearchRequest(),
            name: ""
        };
    }

    private getSearchRequest(fixRequest: boolean = true): Models.IAdvancedSearchModel {
        // fix up betweens searches by adding the value to the charDatas that the api actually looks for
        // this was done this way because of how rl-char-data-elements work
        // also reset the multiIndicator
        var groups = _.cloneDeep(this.searchGroups);
        _.each(groups, (group) => {
            _.each(group.operations, (op) => {

                var key = this.getCmdHash(op.charTypeID, op.characteristicMetaData[0].characteristicID);
                if (this.multiIndicatorRestoreDictionary[key]) {
                    if (this.multiIndicatorRestoreDictionary[key].multiIndicator !== undefined) {
                        op.characteristicMetaData[0].multipleIndicator = this.multiIndicatorRestoreDictionary[key].multiIndicator;
                    }

                    if (this.multiIndicatorRestoreDictionary[key].maxLength !== undefined) {
                        op.characteristicMetaData[0].maxLength = this.multiIndicatorRestoreDictionary[key].maxLength;
                    }
                }

                if (op.betweenCharDatas) {
                    if (op.betweenCharDatas[0] && op.betweenCharDatas[0].value) {
                        if (op.charDatas[1]) {
                            op.charDatas[1] = op.betweenCharDatas[0];
                        } else {
                            op.charDatas.push(op.betweenCharDatas[0]);
                        }
                    }
                }
            });
        });

        var sortField = this.sortField;

        if (sortField == 'title') {
            sortField = 'title_sort';
        }
        return {
            charTypeID: this.charTypeId,
            searchGroups: groups,
            keywords: this.keywords,
            page: this.page,
            rowCount: this.rowCount,
            templateGroupIDs: this.templateGroupIds,
            template: this.selectedTemplate,
            status: this.selectedStatus,
            sortDir: this.sortDir,
            sortField: sortField,
            relatedToMe: this.relatedToMe
        }
    }

    private setSearchRequest(savedSearch: Models.ISaveSearchModel) {
        var req = savedSearch.searchRequest;

        if (req) {
            req.searchGroups.forEach((group) => {
                group.operations.forEach((op) => {
                    this.adjustCharMetaData(op.charTypeID, op.characteristicMetaData[0]);
                });
            });
        }

        this.charTypeId = req.charTypeID;
        this.searchGroups = req.searchGroups;
        this.keywords = req.keywords;
        this.page = 1;
        this.rowCount = req.rowCount;
        this.templateGroupIds = req.templateGroupIDs;
        this.selectedTemplate = req.template;
        this.selectedStatus = req.status;
        this.sortDir = req.sortDir;
        this.sortField = req.sortField;
        this.relatedToMe = req.relatedToMe;
        this.PushState();
    }

    // TODO: Make sure this isn't getting called more than it needs to be
    Search(resetPage?: boolean) {
        if (resetPage) {
            this.page = 1;
        }

        this.searching = true;
        this.notifyService.startProgress();

        var req = this.getSearchRequest();
        //console.log( "Request = \n" + JSON.stringify( req));

        this.getVisibleTemplates().then((visibleTemplates) => {
            var filterByTemplateIds = _.map(visibleTemplates, v => v.templateID);
            req.filterByTemplateIds = filterByTemplateIds;

            this.searchService.advancedSearch(req)
                .then((res) => {
                    this.itemRows = [];
                    this.itemRows = res.documents;
                    this.qTime = res.qTime;
                    this.numFound = res.numFound;
                    this.pageCount = Math.ceil(res.numFound / this.rowCount);
                    this.templateFacets = res.getTemplateFacets();
                    this.statusFacets = res.getStatusFacets();
                })
                .finally(() => {
                    this.searching = false;
                    this.notifyService.endProgress();
                });
        });
    }

    private loadSavedSearches() {
        this.notifyService.startProgress();

        this.searchService.getSavedSearches(this.charTypeId)
            .then((res) => {
                this.savedSearches = res;
            })
            .finally(() => {
                this.notifyService.endProgress();
                this.searching = false;
            });
    }

    private SaveSearchAs(saveSearchModel: Models.ISaveSearchModel, saveAsName: string) {
        if (!_.isEmpty(saveAsName)) {
            saveSearchModel.name = saveAsName;
            saveSearchModel.id = null;  // will trigger a new record
        }
        this.SaveSearch(saveSearchModel);
    }

    SaveSearch(saveSearchModel?: Models.ISaveSearchModel) {

        var toSave: Models.ISaveSearchModel = saveSearchModel ? saveSearchModel : this.saveSearchModel;
        var isUpdate: boolean = (toSave.id != null) && (!_.isEmpty(toSave.id));

        if (toSave === undefined) {
            throw new Error("Define Save Search Model");
        }
        this.notifyService.startProgress();

        var search = this.getSearchRequest(false);
        toSave.searchRequest = search;

        this.searchService.saveSearch(toSave)
            .then((res) => {
                this.AddOrUpdateSavedSearch(res.data);
                this.selectedSavedSearch = res.data;
            }, (err) => {
            })
            .finally(() => {
                this.notifyService.endProgress();
                this.ResetSaveModel();
                this.PushState(true);
            });
    }

    private AddOrUpdateSavedSearch(search: Models.ISaveSearchModel) {
        var existingSavedSearchIndex: number = _.isEmpty(search.id) ? -1 : _.findIndex(this.savedSearches, savedSearch => savedSearch.id === search.id)
        if (existingSavedSearchIndex >= 0) {
            this.savedSearches[existingSavedSearchIndex] = search;
        }
        else {
            this.savedSearches.push(search);
        }
    }

    private ConfirmDelete(search: Models.ISaveSearchModel): boolean {
        var conrifmMsg = "Are you sure you want to delete the search '" + search.name + "'?";
        var ret = this.$window.confirm(conrifmMsg);
        return ret;
    }

    DeleteSearch(search: Models.ISaveSearchModel) {

        if (this.ConfirmDelete(search)) {

            this.notifyService.startProgress();

            //Get the index of the to be deleted search
            var index = this.savedSearches.indexOf(search);

            this.searchService.deleteSearch(search)
                .then((res) => {
                    this.savedSearches.splice(index, 1);
                    this.selectedSavedSearch = null;
                    this.ResetSaveModel();
                    this.searchGroups = [];
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    DeleteOperation(operation: Models.ISearchOperation) {
        this.removeOperation(operation);
        this.PushState(true);
    }

    CancelEdit() {
        this.currentEditSearchGroups = [];
    }

    DropSuccessHandler($event: ng.IAngularEvent, index: number, array: Models.ISearchOperation[]) {
        this.removeOperation(array[index]);
    }

    OnDrop($event: ng.IAngularEvent, $data: Models.ISearchOperation, array: Models.ISearchOperation[]) {
        array.push($data);

        this.PushState();
    }

    Export() {
        var searchRequest = this.getSearchRequest();

        var exportRequest: Models.ISearchExportModel = {
            searchRequest: searchRequest,
            headerColumns: this.selectedColumns
        };

        this.notifyService.startProgress();
        this.searchService.export(exportRequest)
            .then((result) => {
                if (result.data) {
                    alert(result.message);
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    private OpenAdvancedSearchDialog(charTypeId: number, charMetaDatas: Models.ITemplateCharacteristicMetaData[], existingSearchGroups?: Models.ISearchGroup[]) {
        var tcmd = charMetaDatas[0];
        var operation: Models.ISearchOperation;
        this.addSearchGroups = [];
        if (existingSearchGroups.length > 0) {
            _.forEach(existingSearchGroups, (eg) => {
                var operations = eg.operations;
                _.forEach(operations, (op) => {
                    if (op.characteristicMetaData[0].dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money) {
                        _.forEach(op.charDatas, (cd) => {
                            var values: string[] = cd.value.split(" ");
                            var moneyValue: Models.ICharDataMoneyValue = {
                                locAmt: values[1],
                                locSym: values[0]
                            };
                            cd.value = Utils.JsonUtil.Stringify(moneyValue);
                        });

                        if (op.comparator == Consts.AdvancedSearch.Comparator.Between && op.betweenCharDatas.length > 0) {
                            var alreadyMoneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(op.betweenCharDatas[0].value, {});
                            if (_.isEmpty(alreadyMoneyValue)) {
                                var values: string[] = op.betweenCharDatas[0].value.split(" ");
                                var moneyValue: Models.ICharDataMoneyValue = {
                                    locAmt: values[1],
                                    locSym: values[0]
                                };
                                op.betweenCharDatas[0].value = Utils.JsonUtil.Stringify(moneyValue);
                            }
                        }
                    }
                    this.adjustCharMetaData(op.charTypeID, op.characteristicMetaData[0]);
                    if (op.comparator == Consts.AdvancedSearch.Comparator.Between) {
                        if (op.betweenCharDatas.length == 0 && op.charDatas.length == 2) {
                            op.betweenCharDatas.push(op.charDatas[1]);
                        }
                    }
                });
                this.addSearchGroups.push({
                    operator: eg.operator,
                    operations: operations
                });
            });
            this.searchCriteriaEditMode = true;
        }
        else {
            operation = this.CreateDefaultOperation(charTypeId, tcmd.characteristicMetaData);
            this.addSearchGroups.push({
                operator: Consts.AdvancedSearch.Operator.And,
                operations: [operation]
            });
            this.searchCriteriaEditMode = false;
        }
        //this.editSearchGroups = (existingSearchGroups != null) ? _.cloneDeep(existingSearchGroups) : [];
        this.openModal = true;
        return;
    }

    private ShowAdvancedSearchDialog(existingSearchGroups?: Models.ISearchGroup[]) {
        var existingGroups: Models.ISearchGroup[] = (existingSearchGroups != null) ? existingSearchGroups : [];
        if (this.charMetaDatas && (this.charMetaDatas.length > 0)) {
            this.OpenAdvancedSearchDialog(this.selectedCharTypeID, this.charMetaDatas, existingGroups);
        }
        else {
            this.loadCharMetaData(this.charTypeId).then(() => {
                this.OpenAdvancedSearchDialog(this.selectedCharTypeID, this.charMetaDatas, existingGroups);
            });
        }
        return;
    }

    public NewSearch() {
        this.ClearSearch();     // Q: Should we really have to clear the search? Should really only clear if they apply / save something (not if they cancel)
        this.ResetSaveModel();
        this.ShowAdvancedSearchDialog();
    }

    public EditSearch(search: Models.ISaveSearchModel) {
        var existingGroups: Models.ISearchGroup[] = ((search == null) || (search.searchRequest == null) || (search.searchRequest.searchGroups == null))
            ? null
            : search.searchRequest.searchGroups;

        if (existingGroups.length > 0) {
            this.currentEditSearchGroups = _.cloneDeep(existingGroups);
        }
        else {
            this.currentEditSearchGroups = [];
        }

        this.saveSearchModel = search;
        this.LoadSaveSearchModelForDialog(search);
        this.ShowAdvancedSearchDialog(this.currentEditSearchGroups);
        return;
    }

    private LoadSaveSearchModelForDialog(search: Models.ISaveSearchModel) {

        this.ResetSaveModel();

        if (search) {
            this.saveSearchModel.name = search.name;
            this.saveSearchModel.showOnDashboard = search.showOnDashboard;
            this.saveSearchModel.id = search.id;
        }
    }

    private GetActiveSavedSearch(): Models.ISaveSearchModel {
        if (this.selectedSavedSearch != null) {
            var origionalSavedSearch: Models.ISaveSearchModel = _.find(this.savedSearches, savedSearch => savedSearch.id === this.selectedSavedSearch.id);
            return origionalSavedSearch != null ? origionalSavedSearch : this.selectedSavedSearch;
        }
        return null;
    }

    public EditActiveSearch() {
        this.searchCriteriaEditMode = true;
        //this.IsEditingSavedSearch = true;
        var searchToEdit: Models.ISaveSearchModel = this.GetActiveSavedSearch();
        var searchGroups: Models.ISearchGroup[] = (searchToEdit == null) || (searchToEdit.searchRequest == null) || (searchToEdit.searchRequest.searchGroups == null)
            ? this.searchGroups
            : searchToEdit.searchRequest.searchGroups;

        if (searchGroups.length > 0) {
            this.currentEditSearchGroups = _.cloneDeep(searchGroups);
        }
        else {
            this.currentEditSearchGroups = [];
        }

        this.LoadSaveSearchModelForDialog(searchToEdit);
        this.ShowAdvancedSearchDialog(this.currentEditSearchGroups);
        return;
    }

    private RemoveEmptySearchGroupData(searchGroup: Models.ISearchGroup) {
        searchGroup.operations.forEach(op => op.charDatas = op.charDatas.filter(itm => !_.isEmpty(itm.value)));
        searchGroup.operations = searchGroup.operations.filter(op => op.charDatas.length > 0);
    }

    private GetAllSearchCriteriaFromDialog() {
        this.addSearchGroups.forEach(searchGroup => this.RemoveEmptySearchGroupData(searchGroup));
        var newSearchGroupsToAdd: Models.ISearchGroup[] = this.addSearchGroups.filter(searchGroup => searchGroup.operations.length > 0);
        var allSearchGroups: Models.ISearchGroup[] = newSearchGroupsToAdd;
        return allSearchGroups;
    }

    private AdjustBetweenCharDatas(searchGroups: Models.ISearchGroup[]) {
        searchGroups.forEach(searchGroup => {
            searchGroup.operations.forEach(operation => {
                if (operation.characteristicMetaData[0].dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money) {
                    _.forEach(operation.charDatas, (cd) => {
                        if (!_.isEmpty(cd.value)) {
                            var cdMoneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(cd.value, {});
                            cd.value = cdMoneyValue.locSym + " " + cdMoneyValue.locAmt;
                        }
                    });
                    if (operation.betweenCharDatas.length > 0) {
                        if (!_.isEmpty(operation.betweenCharDatas[0].value)) {
                            var bcdMoneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(operation.betweenCharDatas[0].value, {});
                            if (!_.isEmpty(bcdMoneyValue)) {
                                operation.betweenCharDatas[0].value = bcdMoneyValue.locSym + " " + bcdMoneyValue.locAmt;
                            }
                        }
                    }
                }

                if (operation.betweenCharDatas) {
                    if (operation.comparator == Consts.AdvancedSearch.Comparator.Between) {
                        if (operation.betweenCharDatas[0] && operation.betweenCharDatas[0].value) {
                            if (operation.charDatas[1]) {
                                operation.charDatas[1] = operation.betweenCharDatas[0];
                            } else {
                                operation.charDatas.push(operation.betweenCharDatas[0]);
                            }
                        }
                    }
                    else {
                        operation.betweenCharDatas = [];
                    }
                }
            });
        });
    }

    private ResetAdvancedSearchDialogData() {
        this.addSearchGroups = [];
        //this.editSearchGroups = [];
        this.saveSearchModel = null;
        this.saveAsSearchName = "";
        return;
    }

    public SaveAndApplySearchCriteria() {
        var searchToSave: Models.ISaveSearchModel = _.cloneDeep(this.saveSearchModel);
        var allSearchGroups: Models.ISearchGroup[] = this.GetAllSearchCriteriaFromDialog();
        this.AdjustBetweenCharDatas(allSearchGroups);
        this.searchGroups = allSearchGroups;  // so that the GetCurrentSearch() method will function correctly when we save                        
        if (!_.isEmpty(this.saveSearchModel.name) || !_.isEmpty(this.saveAsSearchName)) {
            if (!_.isEmpty(this.saveAsSearchName)) {
                this.SaveSearchAs(searchToSave, this.saveAsSearchName);
            }
            else {
                this.SaveSearch(searchToSave);
            }
        }
        else {
            this.PushState(true);
            //this.Search(true);          // NOTE: only do this we didn't save / save will apply the search
        }
        this.ResetAdvancedSearchDialogData();
        this.openModal = false;
    }

    public ClearModalSearchCriteria() {
        //this.editSearchGroups = [];
    }

    private CreateDefaultOperation(charTypeId: number, characteristicMetadata: Models.ICharacteristicMetaData, operator: Consts.AdvancedSearch.Operator = Consts.AdvancedSearch.Operator.And): Models.ISearchOperation {

        var comparators: { [id: number]: string } = this.getComparators(characteristicMetadata);
        var comparator = this.getFirstComparator(comparators);

        var ret: Models.ISearchOperation = {
            charTypeID: charTypeId,
            operator: operator,
            comparator: comparator,
            characteristicMetaData: [characteristicMetadata],
            charDatas: this.getEmptyCharData(characteristicMetadata),
            betweenCharDatas: this.getEmptyCharData(characteristicMetadata)
        };

        return ret;
    }

    public AddSearchCriteria() {
        var characteristicMetaData = this.charMetaDatas[0].characteristicMetaData;
        var operation: Models.ISearchOperation = this.CreateDefaultOperation(this.selectedCharTypeID, characteristicMetaData);
        this.searchCriteriaEditMode = false;
        this.addSearchGroups.push({
            operator: Consts.AdvancedSearch.Operator.And,
            operations: [operation]
        });
    }

    public LoadSearch(search: Models.ISaveSearchModel) {
        this.loadCharMetaData(this.charTypeId).then(() => {
            this.selectedSavedSearch = search;
            this.setSearchRequest(this.selectedSavedSearch);
        });
    }

    public get selectedSavedSearch(): Models.ISaveSearchModel { return this._selectedSavedSearch; }
    public set selectedSavedSearch(newval: Models.ISaveSearchModel) { this._selectedSavedSearch = _.cloneDeep(newval); }

    public get IsEditingSavedSearch(): boolean {
        return (this.saveSearchModel != null) && (this.saveSearchModel.id != null) && (!_.isEmpty(this.saveSearchModel.id));
    }

    public RemoveOperationFromEdit(operation: Models.ISearchOperation) {
        //this.editSearchGroups = this.editSearchGroups.filter(searchGroup => !searchGroup.operations.some(oper => oper === operation));
    }

    public EditSearchCriteria(operation: Models.ISearchOperation) {
        //var editSearchGroup = _.find(this.editSearchGroups, e => e.operations.some(oper => oper == operation));
        //console.log(editSearchGroup);
        //this.searchCriteriaEditMode = true;
        //this.addSearchGroups.push({
        //    operator: editSearchGroup.operator,
        //    operations: editSearchGroup.operations
        //});
    }

    public BulkActionComplete() {
        this.$timeout(() => {
            this.Search();
        }, 1000);
    }
}
